import { Component, Input } from '@angular/core';
import { ProformsAdminService } from '../../../services/proforms/proforms-admin.service';
import { CreateProFormItemPayload } from '../../../types/payloads/proforms.payloads';
import { ProformFieldTypes } from '../../../types/responses/proforms.responses';

@Component({
  selector: 'app-proforms-add-form-item',
  standalone: false,

  templateUrl: './proforms-add-form-item.component.html',
  styleUrl: './proforms-add-form-item.component.scss',
})
export class ProformsAddFormItemComponent {
  @Input() current_question_id: number;

  @Input() sectionId: number;

  @Input() formId: number;

  readonly ProformFieldTypes = ProformFieldTypes;

  constructor(private proformsAdminService: ProformsAdminService) {}

  createItem(fieldType: ProformFieldTypes) {
    const payload: CreateProFormItemPayload = {
      field_type: fieldType,
      question: 'Question',
      helper_text: '',
      after_item_id: this.current_question_id,
    };
    this.proformsAdminService.createQuestion(this.sectionId, payload);
  }

  // this will need more work
  // createSection() {
  //   const payload: CreateSectionPayload = {
  //     title: 'Untitled Section',
  //     description: '',
  //     next_section: '',
  //   };
  //   this.proformsAdminService.createSection(this.formId, payload).subscribe();
  // }
}
